const PageLoader = () => {
  return (
    <div className="loader-wrapper">
      <img src="/images/loader.gif" alt="Loading..." />
    </div>
  );
};

export default PageLoader;
